import { FileExtension, IFileExtensionContext } from 'tessa/ui/files';
import { Card } from 'tessa/cards';
import { createCardModel, MenuAction, SeparatorMenuAction, showNotEmpty, UIButton } from 'tessa/ui';
import { CdCardTypes } from '../Helpers/CdCardTypes';
import { CdContextMenuFileHelper } from './CdContextMenuFileHelper';
import { createTypedField, DotNetType, Guid } from 'tessa/platform';
import { showFormDialog } from 'tessa/ui/uiHost';
import { CardNewRequest, CardService } from 'tessa/cards/service';
import { MetadataStorage } from 'tessa';
import { CdApprovalListHelper } from '../Helpers/CdApprovalListHelper';

export class CdPrintApprovalListFileExtension extends FileExtension {
  public openingMenu(context: IFileExtensionContext) {
    let card: Card = context.control.model.card;
    if (card.typeId !== CdCardTypes.ArContractTypeID) {
      return;
    }

    // @ts-ignore
    let cardFile = card.files.find(x => x.rowId === context.file.id).card;    
      this.AddMenuAction(context, () => CdPrintApprovalListFileExtension.SaveFileForPrint(card, context));
      return;
  }

  private static async SaveFileForPrint(card: Card, fileContext: IFileExtensionContext) {
      let dialogsType = MetadataStorage.instance.cardMetadata.getCardTypeByName("PkDialogs");
    if (!dialogsType) {
      return;
    }

    let dialogForm = dialogsType.forms.find(x => x.name === "PrintApprovalListVersion");
    if (!dialogForm) {
      return;
    }

    let request = new CardNewRequest();
    request.cardTypeId = dialogsType.id;
    let response = await CardService.instance.new(request);
    response.card.id = Guid.newGuid();
    await showNotEmpty(response.validationResult.build());
    if (!response.validationResult.isSuccessful) {
      return;
    }

    response.card.id = card.id;

    let windowCardModel = createCardModel(response.card, response.sectionRows);
    await showFormDialog(
      dialogForm,
      windowCardModel,
      async (viewModel) => {
        let section;
        if ((section = viewModel.cardModel.card.sections.tryGet('PkPrintApprovalListVersionVirtual')) != null) {
          section.fields.set("VersionID",  1, DotNetType.Int32);
          section.fields.set("VersionCaption",  "печать последней версии", DotNetType.String);
        }
      },
      [
        new UIButton('сохранить', async (btn) => {
          let pkPrintApprovalListVersionVirtual = windowCardModel.card.sections.tryGet('PkPrintApprovalListVersionVirtual'); 
          let pkExternalBuilderApproverVirtual = windowCardModel.card.sections.tryGet('PkExternalBuilderApproverVirtual');  
          // при формировании листа согласования договора, если version 0 - то печать всех версий, если 1 - то последней версии 
          let versionType = pkPrintApprovalListVersionVirtual!.fields.tryGet("VersionID");
          // если организация не указана, то печать по всем организациям
          let organizationExtID = pkExternalBuilderApproverVirtual!.fields.tryGet("PartnerExternalID");
          let info = { 
            'Version': createTypedField(versionType, DotNetType.Int32), 
            'Organization': organizationExtID != null ? createTypedField(organizationExtID, DotNetType.Int64) : null 
          };
          CdContextMenuFileHelper.SaveFileForPrint(fileContext.file, card, CdApprovalListHelper.ApprovalListName, card.typeId, card.typeName, ".html", info);
          btn.close();
        }),
        new UIButton('отмена', (btn) => {
          btn.close();
        }),
      ]
    );
  }

  private AddMenuAction(context: IFileExtensionContext, action: any) {
    // Вставляем действие до ЭЦП
    let actionIndex: number | null = -1;
    context.actions.forEach(action => {
      if (action.name === 'PrintApprovalList') {
        actionIndex = context.actions.indexOf(action);
      }
    });

    context.actions.splice(actionIndex, 0, new SeparatorMenuAction(false));

    context.actions.splice(
      actionIndex,
      0,
      new MenuAction(
        'PrintApprovalList',
        'Печать',
        "ta icon-thin-048",
        action,
        null,
        false
    ));
  }
}
